import { render, staticRenderFns } from "./ProjectNoteDialog.vue?vue&type=template&id=ba3cb042&scoped=true&"
import script from "./ProjectNoteDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectNoteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectNoteDialog.vue?vue&type=style&index=0&id=ba3cb042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3cb042",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VSpacer,VTextField})
